export default function getResource(label, vars = []) {
    const resources = {
        title: 'Points Activity',
        backLink: 'Back to Beauty Insider',
        viewMoreTransactionsText: 'View more transactions',
        recentRecordsText: `Only your most recent ${vars[0]} records are available to display.`,
        noPoints: 'Your points activity will appear here.',
        doNotSeePoints: 'Don\'t see your points yet? Your activity will update within 24 hours.',
        errorLoadingPoints: 'We couldn\'t load your points activity right now. Please try again later.',
        retry: 'Retry'
    };

    return resources[label];
}
